import { render, staticRenderFns } from "./LeadHistory.vue?vue&type=template&id=0864b665&scoped=true"
import script from "./LeadHistory.vue?vue&type=script&lang=js"
export * from "./LeadHistory.vue?vue&type=script&lang=js"
import style0 from "./LeadHistory.vue?vue&type=style&index=0&id=0864b665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864b665",
  null
  
)

export default component.exports